// extracted by mini-css-extract-plugin
export default {"tips":"ExternalStaffManage_tips__YPiFt","modalContentSty":"ExternalStaffManage_modalContentSty__Kkn7A"};